import { DatePicker } from 'antd';
import React from 'react';

import type { DatePickerProps } from 'antd';

type Props = {
  onChange: (date: Date) => void;
  value: Date;
  startDate?: string;
  endDate?: string;
  allowHistoric?: boolean;
  placeholder?: string;
};

export const DateInput = ({
  onChange,
  value,
  startDate,
  endDate,
  allowHistoric,
  placeholder = 'Startdatum',
}: Props) => {
  const start = startDate ? new Date(startDate) : new Date();
  const end = endDate ? new Date(endDate) : null;
  const disableDate: DatePickerProps['disabledDate'] = (current) => {
    if (!current || allowHistoric) {
      return false;
    }

    const currentDate = current.isValid?.() ? current.toDate() : current;
    const isBeforeStart = currentDate < start;
    const isAfterEnd = end ? currentDate > end : false;
    const day =
      currentDate instanceof Date ? currentDate.getDay() : current.day();
    const isWeekend = day === 0 || day === 6;

    return isBeforeStart || isAfterEnd || isWeekend;
  };

  return (
    <DatePicker
      format="DD/MM/YY"
      placeholder={placeholder}
      defaultValue={value}
      disabledDate={disableDate}
      style={{ display: 'block' }}
      required={true}
      onChange={onChange}
    />
  );
};

export default DateInput;
